import { useTranslation } from "react-i18next";

// The Creavision mark from VisionPlatform brand/ (copied to public/, never redrawn). Header: 28–32 px; sign-in
// page: 96–128 px (brand/README.md). It is drawn for light backgrounds.
export function Logo({ size }: { size: number }) {
  const { t } = useTranslation();
  return <img src="/creavision-mark.svg" width={size} height={size} alt={t("app.name")} className="shrink-0" />;
}
